import type { ProjectDocument } from '../types/project';

// ------------------------------------------------------------
// Undo / redo document snapshots (not viewport or selection)
// ------------------------------------------------------------

export const HISTORY_LIMIT = 50;

export function cloneDocument(document: ProjectDocument): ProjectDocument {
  return structuredClone(document);
}

export function trimHistoryStack(
  stack: ProjectDocument[],
): ProjectDocument[] {
  if (stack.length <= HISTORY_LIMIT) return stack;
  return stack.slice(stack.length - HISTORY_LIMIT);
}

export function pushDocumentSnapshot(
  past: ProjectDocument[],
  document: ProjectDocument,
): ProjectDocument[] {
  const snapshot = cloneDocument(document);
  const last = past[past.length - 1];
  if (last && JSON.stringify(last) === JSON.stringify(snapshot)) {
    return past;
  }
  return trimHistoryStack([...past, snapshot]);
}
